module.exports = __webpack_public_path__ + "static/media/project-3.8223e72b.jpg";